/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var Broker =
/** @class */
function () {
  function Broker(api, tokenService) {
    var _this = this;

    this._baseUri = "";

    this.Fetch = function (url, options) {
      return __awaiter(_this, void 0, void 0, function () {
        var headers, token;

        var _this = this;

        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              headers = new Headers();
              headers.set("Accept", "application/json");
              headers.set("Content-Type", "application/json");
              return [4
              /*yield*/
              , this._tokenService.getAsync()];

            case 1:
              token = _a.sent();

              if (token.bearer) {
                headers.set("Authorization", "Bearer " + token.bearer);
              }

              return [2
              /*return*/
              , fetch(this._baseUri + "/" + url, _assign({
                headers: headers
              }, options)).then(function (response) {
                return __awaiter(_this, void 0, void 0, function () {
                  var t, json, error_1;
                  return __generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        if (response.ok) {
                          return [2
                          /*return*/
                          , response.json()];
                        }

                        _a.label = 1;

                      case 1:
                        _a.trys.push([1, 3,, 4]);

                        return [4
                        /*yield*/
                        , response.text()];

                      case 2:
                        t = _a.sent();

                        try {
                          json = JSON.parse(t);

                          if (json.error !== "") {
                            throw Error(json.error);
                          } else {
                            throw Error(response.statusText);
                          }
                        } catch (e) {
                          throw e;
                        }

                        return [3
                        /*break*/
                        , 4];

                      case 3:
                        error_1 = _a.sent();
                        throw error_1;

                      case 4:
                        return [2
                        /*return*/
                        ];
                    }
                  });
                });
              }).catch(function (ex) {
                throw ex;
              })];
          }
        });
      });
    };

    this._tokenService = tokenService;
    this._baseUri = "https://jrnal-" + api + "-api.appspot.com";
  }

  return Broker;
}();

var AllColors = {
  JrnalRed: "#ed3752",
  JrnalBlue: "#324d5c",
  JrnalOrange: "#e37b40",
  JrnalYellow: "#f0ca4d",
  Grey: "#777777",
  LightGrey: "#f8f8f8",
  Green: "#038C73",
  BackgroundBlue: "#365260",
  BorderGrey: "#cdcdcd",
  White: "#ffffff",
  TextSecondary: "#787878"
};
var LogoColors = {
  Red: AllColors.JrnalRed,
  Blue: AllColors.JrnalBlue,
  Orange: AllColors.JrnalOrange,
  Yellow: AllColors.JrnalYellow
};
var FontSizes = {
  Title: 22,
  Copy: 16,
  Small: 13
};
var TextColors = {
  Primary: AllColors.JrnalBlue,
  Secondary: AllColors.Grey,
  PrimaryOnDark: AllColors.White,
  SecodaryOnDark: AllColors.LightGrey,
  Warning: AllColors.JrnalOrange,
  Error: AllColors.JrnalRed
};
var LayoutColors = {
  Seperator: AllColors.BorderGrey,
  ButtonGreen: AllColors.Green,
  BackgroundBlue: AllColors.BackgroundBlue,
  BackgroundGrey: AllColors.LightGrey,
  BackgroundSecondary: AllColors.JrnalYellow,
  BackgroundWhite: AllColors.White,
  BackgroundError: AllColors.JrnalRed
};

var StringHelpers =
/** @class */
function () {
  function StringHelpers() {}

  StringHelpers.TrimToLength = function (text, n) {
    var clean = text.trim();
    return clean.length > n ? clean.substr(0, n - 1) + "..." : clean;
  };

  return StringHelpers;
}();

var ResidentHelpers =
/** @class */
function () {
  function ResidentHelpers() {}

  ResidentHelpers.GetInitials = function (su) {
    return "" + su.firstname.charAt(0) + su.lastname.charAt(0);
  };

  return ResidentHelpers;
}();

var DateHelpers =
/** @class */
function () {
  function DateHelpers() {}

  DateHelpers.TimeSince = function (date) {
    var seconds = Math.floor(new Date().getDate() / 1000 - date.getDate());
    var interval = Math.floor(seconds / 31536000);
    if (interval > 1) return interval + "y";
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) return interval + "m";
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) return interval + "d";
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) return interval + "h";
    interval = Math.floor(seconds / 60);
    if (interval > 1) return interval + " m";
    return Math.floor(seconds) + "s";
  };

  return DateHelpers;
}();

var Worker =
/** @class */
function () {
  function Worker() {}

  Worker.Empty = {
    error: "",
    isWorking: false
  };

  Worker.Error = function (message) {
    return {
      error: message,
      isWorking: false
    };
  };

  Worker.Start = {
    error: "",
    isWorking: true
  };
  return Worker;
}();

export { Broker, FontSizes, TextColors, LayoutColors, LogoColors, StringHelpers, ResidentHelpers, DateHelpers, Worker };